import { TitanButton } from "../../control/TitanButton";
import { DialogData } from "../../control/data/DialogData";
import { CommonLang } from "../lang/CommonLang";
import { MessageDialog } from "./MessageDialog";
/**
 * PromptDialog.ts
 */
export class PromptDialog extends MessageDialog {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.properties = properties;
    }
    createButtons() {
        this.createCancelButton();
        this.createConfirmButton();
    }
    createCancelButton() {
        this.cancelButton = new TitanButton(this.properties.cancelButtonProperties);
        this.cancelButton.name = "cancelButton";
        this.cancelButton.onClick(this.handleCancelButtonSelected, this);
        this.addChild(this.cancelButton);
    }
    handleCancelButtonSelected() {
        this.handleCancel();
    }
    updateButtons() {
        this.updateButton(this.cancelButton, DialogData.CANCEL, CommonLang.NO_BUTTON);
        this.updateButton(this.confirmButton, DialogData.CONFIRM, CommonLang.YES_BUTTON);
    }
}
//# sourceMappingURL=PromptDialog.js.map